import { render } from "./NewCardPaymentForm.vue?vue&type=template&id=2bcd2136"
import script from "./NewCardPaymentForm.vue?vue&type=script&lang=js"
export * from "./NewCardPaymentForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__